import ApiModel from '@/model/ApiModel'
let { Const } = ApiModel;

const state = {
    //直播间列表
    liveRoom: {
        all: {
            viewType: 1,
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                roomId: null,
                roomTitle: '',
                roomType: null,
                globalCategoryNameLike: '',
                categoryId: '',
                categoryName: '',
                publishStatus: null,
                userCode: '',
                sortType: 2,
                status: null
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 直播专题
    liveCategory: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                // id: null,
                nameLike: null,
                publishStatus: null,
            },
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 相关报道
    relatedReport: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                titleLike: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 直播记录
    liveRecord: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                roomId: null,
                roomTitleLike: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    //素材分类
    category: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                topicName: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    //素材
    material: {
        all: {
            filter: {
                type: 1,
                name: '',
                topicId: null
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    //水印
    watermark: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                watermarkName: '',
                watermarkType: null,
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 云导播
    director: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                nameLike: '',
                status: null,
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 部门模板
    departmentTemplate: {
        all: {
            filter: {
                nameLike: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 素材模板
    materialTemplate: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                nameLike: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 云编辑
    cloudEditor: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                nameLike: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        },
        outputTask: {
            filter: {
                depId: 0,
                taskId: null,
                titleLike: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 实时编辑
    realEditor: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                nameLike: '',
                status: null,
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 云演播
    virtualOffice: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                nameLike: '',
                status: null,
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 云演播厅模板
    virtualOfficeTemplate: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                templateNameLike: '',
                userCode: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    // 硬件列表
    hardEncoder: {
        all: {
            filter: {
                depId: 0,
                selectType: Const.SelectType.unselected,
                userCode: '',
                deviceCodeLike: null,
                deviceNameLike: ''
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        },
        bingLiveRoom: {
            filter: {
                roomId: null,
                roomTitle: null
            },
            pagination: {
                page: 1,
                total: 0,
                pageSize: 10
            }
        }
    }
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
    "liveRoom.all.viewType"(state, val) {
        state.liveRoom.all.viewType = val;
    },
    "liveRoom.all.filter"(state, val) {
        state.liveRoom.all.filter = val;
    },
    "liveRoom.all.pagination"(state, val) {
        state.liveRoom.all.pagination = val;
    },
    "liveCategory.all.filter"(state, val) {
        state.liveCategory.all.filter = val;
    },
    "liveCategory.all.pagination"(state, val) {
        state.liveCategory.all.pagination = val;
    },
    "relatedReport.all.filter"(state, val) {
        state.relatedReport.all.filter = val;
    },
    "relatedReport.all.pagination"(state, val) {
        state.relatedReport.all.pagination = val;
    },
    "liveRecord.all.filter"(state, val) {
        state.liveRecord.all.filter = val;
    },
    "liveRecord.all.pagination"(state, val) {
        state.liveRecord.all.pagination = val;
    },
    "category.all.filter"(state, val) {
        state.category.all.filter = val;
    },
    "category.all.pagination"(state, val) {
        state.category.all.pagination = val;
    },
    "material.all.filter"(state, val) {
        state.material.all.filter = val;
    },
    "material.all.pagination"(state, val) {
        state.material.all.pagination = val;
    },
    "watermark.all.filter"(state, val) {
        state.watermark.all.filter = val;
    },
    "watermark.all.pagination"(state, val) {
        state.watermark.all.pagination = val;
    },
    "director.all.filter"(state, val) {
        state.director.all.filter = val;
    },
    "director.all.pagination"(state, val) {
        state.director.all.pagination = val;
    },
    "departmentTemplate.all.filter"(state, val) {
        state.departmentTemplate.all.filter = val;
    },
    "departmentTemplate.all.pagination"(state, val) {
        state.departmentTemplate.all.pagination = val;
    },
    "materialTemplate.all.filter"(state, val) {
        state.materialTemplate.all.filter = val;
    },
    "materialTemplate.all.pagination"(state, val) {
        state.materialTemplate.all.pagination = val;
    },
    "cloudEditor.all.filter"(state, val) {
        state.cloudEditor.all.filter = val;
    },
    "cloudEditor.all.pagination"(state, val) {
        state.cloudEditor.all.pagination = val;
    },
    "cloudEditor.outputTask.filter"(state, val) {
        state.cloudEditor.outputTask.filter = val;
    },
    "cloudEditor.outputTask.pagination"(state, val) {
        state.cloudEditor.outputTask.pagination = val;
    },
    "virtualOffice.all.filter"(state, val) {
        state.virtualOffice.all.filter = val;
    },
    "virtualOffice.all.pagination"(state, val) {
        state.virtualOffice.all.pagination = val;
    },
    "virtualOfficeTemplate.all.filter"(state, val) {
        state.virtualOfficeTemplate.all.filter = val;
    },
    "virtualOfficeTemplate.all.pagination"(state, val) {
        state.virtualOfficeTemplate.all.pagination = val;
    },
    "hardEncoder.all.filter"(state, val) {
        state.hardEncoder.all.filter = val;
    },
    "hardEncoder.all.pagination"(state, val) {
        state.hardEncoder.all.pagination = val;
    },
    currentDepId(state, val) {
        state.liveRoom.all.filter.depId = val;
        state.liveCategory.all.filter.depId = val;
        state.relatedReport.all.filter.depId = val;
        state.liveRecord.all.filter.depId = val;
        state.category.all.filter.depId = val;
        state.watermark.all.filter.depId = val;
        state.director.all.filter.depId = val;
        state.materialTemplate.all.filter.depId = val;
        state.cloudEditor.all.filter.depId = val;
        state.realEditor.all.filter.depId = val;
        state.virtualOffice.all.filter.depId = val;
        state.virtualOfficeTemplate.all.filter.depId = val;
        state.hardEncoder.all.filter.depId = val;
    },
    clearLiveRoomAll(state) {
        state.liveRoom.all.filter.roomId = null;
        state.liveRoom.all.filter.roomTitle = '';
        state.liveRoom.all.filter.roomType = null;
        state.liveRoom.all.filter.globalCategoryNameLike = '';
        state.liveRoom.all.filter.categoryNameLike = '';
        state.liveRoom.all.filter.publishStatus = null;
        state.liveRoom.all.filter.userCode = '';
        state.liveRoom.all.pagination.page = 1;
        state.liveRoom.all.pagination.pageSize = 10;
    },
    clearCategoryRoomAll(state) {
        state.liveCategory.all.filter.nameLike = '';
        state.liveCategory.all.filter.publishStatus = null;
        state.liveCategory.all.pagination.page = 1;
        state.liveCategory.all.pagination.pageSize = 10;
    },
    clearRelatedReportAll(state) {
        state.relatedReport.all.filter.titleLike = '';
        state.relatedReport.all.filter.userCode = '';
        state.relatedReport.all.pagination.page = 1;
        state.relatedReport.all.pagination.pageSize = 10;
    },
    clearLiveRecordAll(state) {
        state.liveRecord.all.filter.roomId = null;
        state.liveRecord.all.filter.roomTitleLike = '';
        state.liveRecord.all.filter.userCode = '';
        state.liveRecord.all.pagination.page = 1;
        state.liveRecord.all.pagination.pageSize = 10;
    },
    clearCategoryAll(state) {
        state.category.all.filter.topicName = '';
        state.category.all.filter.userCode = '';
        state.category.all.pagination.page = 1;
        state.category.all.pagination.pageSize = 10;
    },
    clearWatermarkAll(state) {
        state.watermark.all.filter.watermarkName = '';
        state.watermark.all.filter.watermarkType = null;
        state.watermark.all.filter.userCode = '';
        state.watermark.all.pagination.page = 1;
        state.watermark.all.pagination.pageSize = 10;
    },
    clearDirectorAll(state) {
        state.director.all.filter.nameLike = '';
        state.director.all.filter.status = null;
        state.director.all.filter.userCode = '';
        state.director.all.pagination.page = 1;
        state.director.all.pagination.pageSize = 10;
    },
    clearMaterialTemplateAll(state) {
        state.materialTemplate.all.filter.nameLike = '';
        state.materialTemplate.all.filter.userCode = '';
        state.materialTemplate.all.pagination.page = 1;
        state.materialTemplate.all.pagination.pageSize = 10;
    },
    clearCloudEditorAll(state) {
        state.cloudEditor.all.filter.nameLike = '';
        state.cloudEditor.all.filter.userCode = '';
        state.cloudEditor.all.pagination.page = 1;
        state.cloudEditor.all.pagination.pageSize = 10;
    },
    clearRealEditorAll(state) {
        state.realEditor.all.filter.nameLike = '';
        state.realEditor.all.filter.status = null;
        state.realEditor.all.filter.userCode = '';
        state.realEditor.all.pagination.page = 1;
        state.realEditor.all.pagination.pageSize = 10;
    },
    clearVirtualOfficeAll(state) {
        state.virtualOffice.all.filter.nameLike = '';
        state.virtualOffice.all.filter.status = null;
        state.virtualOffice.all.filter.userCode = '';
        state.virtualOffice.all.pagination.page = 1;
        state.virtualOffice.all.pagination.pageSize = 10;
    },
    clearVirtualOfficeTemplateAll(state) {
        state.virtualOfficeTemplate.all.filter.templateNameLike = '';
        state.virtualOfficeTemplate.all.filter.userCode = '';
        state.virtualOfficeTemplate.all.pagination.page = 1;
        state.virtualOfficeTemplate.all.pagination.pageSize = 10;
    },
    clearHardEncoderAll(state) {
        state.hardEncoder.all.filter.deviceNameLike = '';
        state.hardEncoder.all.filter.deviceCodeLike = null;
        state.hardEncoder.all.filter.userCode = '';
        state.hardEncoder.all.pagination.page = 1;
        state.hardEncoder.all.pagination.pageSize = 10;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}